export enum tipoTabella {
  CHECKBOX_SELECTION = 'checkboxSelection',
  TEMPLATING = 'templating'
};

